var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "search-results" }, [
    _c(
      "div",
      { staticClass: "search-results-wrapper" },
      [
        _vm.jobList.length
          ? _c("div", { staticClass: "result-box" }, [
              _c("h5", { staticClass: "result-box__item-number" }, [
                _vm._v(_vm._s(_vm.jobList.length) + " lehetőség"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "result-card-wrapper" },
                _vm._l(_vm.visibleJobs, function (job, index) {
                  return _c(
                    "a",
                    {
                      key: index,
                      staticClass: "result-card",
                      attrs: { href: "/karrier/jobs?jobId=" + job.id },
                    },
                    [
                      _c("p", { staticClass: "result-card__job" }, [
                        _vm._v(_vm._s(job.title)),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "result-card__location" }, [
                        _vm._v(_vm._s(job.location)),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "result-card__employer" }, [
                        _vm._v(_vm._s(job.company)),
                      ]),
                      _vm._v(" "),
                      job.labels.length
                        ? _c(
                            "div",
                            { staticClass: "result-card-labels" },
                            _vm._l(job.labels, function (label, index) {
                              return _c(
                                "span",
                                {
                                  key: index,
                                  staticClass: "result-card-labels__item",
                                },
                                [_vm._v(_vm._s(label))]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("p", { staticClass: "result-box__shown-items" }, [
                _vm._v(
                  "Megjelenítve " +
                    _vm._s(_vm.visibleJobsNumber) +
                    " / " +
                    _vm._s(_vm.jobList.length)
                ),
              ]),
              _vm._v(" "),
              _vm.hasMoreResult
                ? _c(
                    "button",
                    {
                      staticClass: "result-box__button",
                      attrs: { type: "button" },
                      on: { click: _vm.loadMore },
                    },
                    [_vm._v("Továbbiak betöltése")]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._t("default"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }